import type { HeaderProfileBasic } from './types';

const getOptionalString = (value: unknown) =>
  typeof value === 'string' ? value : undefined;

export function toHeaderProfileBasic(
  basic: Partial<HeaderProfileBasic> | null | undefined
): HeaderProfileBasic | null {
  if (!basic) return null;

  return {
    avatar: getOptionalString(basic.avatar),
    email: getOptionalString(basic.email),
    firstName: getOptionalString(basic.firstName),
    id: getOptionalString(basic.id),
    jobTitle: getOptionalString(basic.jobTitle),
    lastName: getOptionalString(basic.lastName),
  };
}

const normalizeNamePart = (value: unknown) =>
  typeof value === 'string' ? value.trim() : '';

export function mergeProfileHeaderBasicName(
  currentProfile: HeaderProfileBasic,
  nextBasic: Partial<Pick<HeaderProfileBasic, 'firstName' | 'lastName'>>
): HeaderProfileBasic {
  const currentFirstName = normalizeNamePart(currentProfile.firstName);
  const currentLastName = normalizeNamePart(currentProfile.lastName);
  const nextFirstName = normalizeNamePart(
    nextBasic.firstName ?? currentProfile.firstName
  );
  const nextLastName = normalizeNamePart(
    nextBasic.lastName ?? currentProfile.lastName
  );

  if (
    currentFirstName === nextFirstName &&
    currentLastName === nextLastName
  ) {
    return currentProfile;
  }

  return {
    ...currentProfile,
    firstName: nextFirstName,
    lastName: nextLastName,
  };
}
